import { z } from 'zod';
import { codigoConsecutivoSchema } from '../codigo-consecutivo';

export const projectSchema = z.object({
  codigo: codigoConsecutivoSchema,
  nombre: z
    .string()
    .min(1, 'Ingrese el nombre')
    .min(2, 'El nombre debe tener al menos 2 caracteres')
    .max(100, 'El nombre no puede superar 100 caracteres'),
  direccion: z
    .string()
    .min(1, 'Ingrese la dirección')
    .min(2, 'La dirección debe tener al menos 2 caracteres')
    .max(200, 'La dirección no puede superar 200 caracteres'),
  ciudad: z
    .string()
    .min(1, 'Ingrese la ciudad')
    .min(2, 'La ciudad debe tener al menos 2 caracteres')
    .max(100, 'La ciudad no puede superar 100 caracteres'),
  matriculaMatriz: z
    .string()
    .min(1, 'Ingrese la matrícula matriz')
    .min(5, 'La matrícula debe tener al menos 5 caracteres')
    .max(50, 'La matrícula no puede superar 50 caracteres'),
});

export type ProjectFormValues = z.infer<typeof projectSchema>;
